import { TBlogModuleHero } from '../../blog/blog.types';
import { BlogArticleModuleHeroDesktop } from './BlogArticleModuleHeroDesktop';
import { BlogArticleModuleHeroMobile } from './BlogArticleModuleHeroMobile';

type Props = {
  module: TBlogModuleHero;
  mobile?: boolean;
};

export const BlogArticleModuleHero: React.FC<Props> = ({
  module,
  mobile = false,
}) => {
  if (mobile) return <BlogArticleModuleHeroMobile module={module} />;

  return <BlogArticleModuleHeroDesktop module={module} />;
};
